<template>
    <div class="reserve">
        <van-button type="info" :to="'/mobile/appointmentDelivery?key=' + params.key" size="large" style="margin-bottom:20px;">预约送货</van-button>
        <van-button type="info" :to="'/mobile/appointmentSearch?key=' + params.key" size="large" style="margin-bottom:20px;">查询预约单</van-button>
        <van-button type="info" :to="'/mobile/appointmentCheck?key=' + params.key" size="large" style="margin-bottom:20px;">办单核收</van-button>
        <van-button type="info" :to="'/mobile/appointmentDeliveryBatch'" size="large" style="margin-bottom:20px;" >批量预约</van-button>
        <!-- <van-button type="info" :to="'/mobile/appointmentArrive?key=' + params.key" size="large" >到仓证明</van-button> -->
    </div>
</template>

<script>
import { Button } from 'vant';
import { getUrlParams } from '../../../../util/util';
export default {
    
    data() {
        return {
            params: {}
        }
    },

    components: {
      [Button.name]: Button
    },

    computed: {
    },

    created() {
        this.init()
    },
    
    mounted(){
    },

    methods: {
        init(){
            const that = this 
            let params = getUrlParams(window.location.href)
            this.params = params
        },
    },
    
    watch: {
    }
}
</script>

<style lang="less" scoped>
    .reserve{
        padding: 10%;
        box-sizing: border-box;
    }
</style>